import { createSlice } from "@reduxjs/toolkit";

const offeringConfigurationSliceState =
{
    leftNavigation: [],
    topNavigation: []
};

const offeringConfigurationSlice = createSlice({
    name: "navigations",
    initialState: offeringConfigurationSliceState,
    reducers: {
        setLeftNavigation(state, action) {
            state.leftNavigation = action.payload;
        },

        setTopNavigation(state, action) {
            state.topNavigation = action.payload;
        },

    },
});

export default offeringConfigurationSlice;